module.exports = __webpack_public_path__ + "2620c8c2/img/chevron-right-icon.253a4260.svg";